"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.result2obj = exports.comps2obj = void 0;
var find_comp,
    indexOf = [].indexOf;

find_comp = function find_comp(comps, name) {
  var comp;
  return function () {
    var i, len, results;
    results = [];

    for (i = 0, len = comps.length; i < len; i++) {
      comp = comps[i];

      if (indexOf.call(comp.types, name) >= 0) {
        results.push(comp.long_name);
      }
    }

    return results;
  }()[0];
}; // converts a google maps data object to something reasonable


var comps2obj = function comps2obj(data) {
  var comps, ref, ref1;

  try {
    comps = data.gmaps.address_components;
    return {
      address: (ref = data.label) != null ? (ref1 = ref.split(',')) != null ? ref1[0] : void 0 : void 0,
      country: find_comp(comps, 'country'),
      region: find_comp(comps, 'administrative_area_level_1'),
      city: find_comp(comps, 'locality') || find_comp(comps, 'postal_town'),
      postal_code: find_comp(comps, 'postal_code'),
      latitude: data.location.lat,
      longitude: data.location.lng
    };
  } catch (error) {
    return null;
  }
};

exports.comps2obj = comps2obj;

var result2obj = function result2obj(result) {
  var comps;

  try {
    comps = result.address_components;
    return {
      address: result.formatted_address,
      country: find_comp(comps, 'country'),
      region: find_comp(comps, 'administrative_area_level_1'),
      city: find_comp(comps, 'locality') || find_comp(comps, 'postal_town'),
      postal_code: find_comp(comps, 'postal_code'),
      latitude: result.geometry.location.lat(),
      longitude: result.geometry.location.lng()
    };
  } catch (error) {
    return null;
  }
};

exports.result2obj = result2obj;